import { getPackageUniqueKey } from 'lib/offer/offerUtils'
import { orderHasBookingProtection } from './orderInsuranceUtils'
import { getMaxOccupancies, getOccupanciesFromReservations } from 'lib/offer/occupancyUtils'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'

export function getExtraGuestCapacity(offer: App.HotelOffer, item: App.OrderItem): {
    adults: number;
    children: number;
    infants: number;
} | null {
  if (!offer) return null
  if (!item?.reservation) return null

  const itemPackage = item.package as App.OrderItemHotelPackage
  const key = getPackageUniqueKey(itemPackage.id, itemPackage.duration, itemPackage.roomRateId)
  const pkg = offer.packages.find(p => p.uniqueKey === key)

  const occupancy = getOccupanciesFromReservations(item.reservation)

  return getMaxOccupancies(pkg?.roomRate.capacities, occupancy, {
    maxChildAge: offer.property.maxChildAge,
    maxInfantAge: offer.property.maxInfantAge,
  })
}

export function canAddExtraGuests(offer: App.HotelOffer, order: App.Order, item: App.OrderItem) {
  if (!offer) return false
  if (!item) return false
  if (!item.reservation) return false

  if (!isFlashHotelOffer(offer)) {
    return false
  }

  const hasBookingProtection = orderHasBookingProtection(order)
  if (hasBookingProtection) return false

  const hasTransfers = order.transferItems.filter(transfer => transfer.status === 'completed').length > 0
  if (hasTransfers) return false

  const maxCapacities = getExtraGuestCapacity(offer, item)
  if (!maxCapacities) return false

  return maxCapacities.adults > item.reservation.adults ||
    maxCapacities.children > (item.reservation.children ?? 0) ||
    maxCapacities.infants > (item.reservation.infants ?? 0)
}
